import React, { useState, useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import useQueryParams from "hooks/use-query-params";
import { serializeObjectInUrlQuery } from "helpers/object";
import Player from "./player/player";
import useCurrentUser from "hooks/use-current-user";
import Loader from "components/common/loader/loader";

const AudioProfile = ({ match }) => {
  const [values, setValues] = useState({ freemiumTrack: 0, init: false });
  const objQueryParams = useQueryParams();
  const queryParams = serializeObjectInUrlQuery(objQueryParams);
  const { permissions } = useCurrentUser();

  useEffect(() => {
    let tempFreemiumTrack = 0;
    let countPermissions = 0;

    //console.log(permissions);

    permissions.ubungen.forEach((t, i) => {
      if (tempFreemiumTrack === 0 && permissions.ubungen[i].name !== false) {
        tempFreemiumTrack = i;        
      }

      if (permissions.ubungen[i].name !== false) {
        countPermissions++;
      }

      

      if (permissions.ubungen.length === i + 1) {
        // If user has access to all tracks, player should start with complete issue
        if (countPermissions === permissions.ubungen.length) tempFreemiumTrack = 0;
        setValues((v) => {
          return {
            init: true,
            freemiumTrack: tempFreemiumTrack,
          };
        });
      }
    });
  }, [permissions, values.init, values.freemiumTrack]);

  if (!values.init) {
    return <Loader position={"absolute"} />;
  }

  return (
    <Switch>
      <Redirect
        from={`${match.url}`}
        to={`${match.url}/track/${values.freemiumTrack}?${queryParams}`}
        exact
      />
      <Route path={`${match.url}/:viewType/:trackId`} component={Player} />
      <Redirect from={`${match.url}/*`} to="/error" />
    </Switch>
  );
};

export default AudioProfile;